import React from 'react';
import { Dialog } from 'primereact/dialog';
import { FormBacterium } from './FormBacterium';

export const ModalBacterium = (props) => {

    const {
        modal, closeDialog, modalTitle, method,
        validaciones,
        bacterium, gram, id_mic_morphology, morphologys,
        antibiograms, antibiogramsSelected, onChangeAntibiogram,
        handleInputChange, loading,
        saveCreate, saveUpdate,
        stainGrams, id_mic_stain_gram,
    } = props;

    return (
        <Dialog 
            header={modalTitle}
            visible={modal}
            onHide={closeDialog}
            closable={true}
            modal
            blockScroll
            className='large-dialog'
            
        >
            {
                method === "create"
                    ? (
                        <FormBacterium
                            button="Crear bacteria"
                            {...{
                                loading, handleInputChange, validaciones,
                                methodAction: saveCreate,
                                morphologys, antibiograms, antibiogramsSelected,
                                onChangeAntibiogram,
                                stainGrams, id_mic_stain_gram,
                                closeDialog
                            }}
                        />
                    )
                    : method === "update"
                        ? (
                            <FormBacterium
                                button="Actualizar bacteria"
                                {...{
                                    loading, handleInputChange, validaciones,
                                    methodAction: saveUpdate,
                                    bacterium, gram, id_mic_morphology,
                                    morphologys, antibiograms, antibiogramsSelected,
                                    onChangeAntibiogram,
                                    stainGrams, id_mic_stain_gram,
                                    closeDialog
                                }}
                            />
                        )
                        : null
            }
        </Dialog>
    );
};
